import { Menu as MenuAntd } from 'antd'
import { MenuProps as MenuPropsAntd } from 'antd'

import s from './Menu.module.scss'
interface MenuProps extends MenuPropsAntd {}

export const Menu = ({ ...props }: MenuProps) => {
  return <MenuAntd className={s.Menu} {...props} />
}
